module.exports = __webpack_public_path__ + "img/Keyword Message.e5528a2b.png";